import React from 'react';

const Lock = ({width = '14px', height = '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.3332 5.66667V4.33333C10.3332 2.49238 8.84079 1 6.99984 1C5.15889 1 3.6665 2.49238 3.6665 4.33333V5.66667M6.99984 8.66667V10M4.8665 13H9.13317C10.2533 13 10.8133 13 11.2412 12.782C11.6175 12.5903 11.9234 12.2843 12.1152 11.908C12.3332 11.4802 12.3332 10.9201 12.3332 9.8V8.86667C12.3332 7.74656 12.3332 7.18651 12.1152 6.75869C11.9234 6.38236 11.6175 6.0764 11.2412 5.88465C10.8133 5.66667 10.2533 5.66667 9.13317 5.66667H4.8665C3.7464 5.66667 3.18635 5.66667 2.75852 5.88465C2.3822 6.0764 2.07624 6.38236 1.88449 6.75869C1.6665 7.18651 1.6665 7.74656 1.6665 8.86667V9.8C1.6665 10.9201 1.6665 11.4802 1.88449 11.908C2.07624 12.2843 2.3822 12.5903 2.75852 12.782C3.18635 13 3.7464 13 4.8665 13Z"
                stroke={color || '#A7A7A8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};
export default Lock;
